import React, { useEffect, useState } from "react";
import "./UserList.css";
import {translate} from "./Language/Translate"
import { BlackWhite } from "./styledComponents/colors";
import { Table, Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Auth from "../helpers/auth";
import UserDetails from "./UserDetails";
import UserEdit from "../newForms2/users/UserEdit";


const UserListItem = ({user}) => {
    const [view, setView] = useState('list');
    const newObj = {};
    ['function', 'email', 'phone', 'mobile'].forEach(i => newObj[i] = user[i] || "");
    // const mayEdit = Auth[auth] || currentUser.username === user.username;
    // console.log({view});
    const {firstName, lastName, title} = user;
    const boldLine = `${title ? `${title} `:""} ${firstName} ${lastName}`
    
    const ListItem = () => {
        // console.log({user, boldLine});
        return(
                
            <li onClick = {() => setView('details')}>
                <BlackWhite>
                    <b>{boldLine}</b> 
                    {Object.entries(newObj)
                        .filter(e => !!e[1])
                        .map(e => <span key={e[0]}>{`, ${translate(e[0])}: ${e[1]}`}</span>)}
                </BlackWhite>
            </li>
        )
    };



    return(
        <>  
            {view === "list" && <ListItem/>}
            {view === "details" && <UserDetails user={user} setView={setView} view={view}/>}
            {view === "form" && <UserEdit user={user} setView={setView} view={view}/>}
            
        
        </>
    )

  };
  export default UserListItem